import html2pdf from "html2pdf.js";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SideBar from "../../../components/b2b/SideBar";
import Header from "../../../components/landingPage/Header";
import { DownloadIcon } from "@heroicons/react/solid";

function Invoice() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { bookingDetailsById } = useSelector((state) => state.booking);
  const { allCompany } = useSelector((state) => state.company);
  const { settings } = useSelector((state) => state.settings);
  const { token } = useSelector((state) => state.auth);
  const [company, setcompany] = useState();

  useEffect(() => {
    dispatch({
      type: "GET_ALL_COMPANY",
      payload: { token },
    });
  }, []);

  useEffect(() => {
    dispatch({ type: "GET_BOOKING_DETAILS_BY_ID", payload: { id: id } });
  }, [dispatch, id]);

  useEffect(() => {
    allCompany?.map((company) => {
      return company?.users?.map((user) => {
        return (
          user?.userName === bookingDetailsById?.userName?.split(" ")[0] &&
          setcompany(company)
        );
      });
    });
  }, [allCompany, bookingDetailsById?.userName]);

  const downloadInvoice = () => {
    const input = document.getElementById("invoice");
    // html2canvas(input, {}).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF("p", "pt", "a4");
    //   pdf.addImage(imgData, "PNG", 30, 5, 550, 820);
    //   // setInvoice_attachment(pdf.output("Voucher.pdf"));
    //   pdf.save("invoice.pdf");
    // });
    html2pdf()
      .set({
        margin: 1,
        filename: "invoice.pdf",
        image: { type: "jpeg", quality: 0.2 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
      })
      .from(input)
      .save("invoice.pdf");
  };

  return (
    <div className="w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="overflow-y-auto h-[90vh] scrollbar-hide md:ml-16">
          <div id="bookingStatus">
            <table
              id="invoice"
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
            >
              <tr>
                <td bgcolor="#ffffff" align="center">
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;border-bottom: 1px solid #b2abab;"
                    style={{
                      maxWidth: "700px",
                      borderBottom: "1px solid #b2abab",
                    }}
                    class="wrapper"
                  >
                    <tr>
                      <td
                        align="left"
                        valign="top"
                        width="40%"
                        //   style="padding: 15px 0;"
                        style={{ padding: "15px 0" }}
                        class="logo"
                      >
                        <img
                          alt="Logo"
                          src={company?.companyLogo?.secure_url}
                          width="200"
                          height="108"
                          // style="display: block; borderRadius: 9px "
                          style={{ display: "block", borderRadius: "9px" }}
                          border="0"
                        />
                      </td>
                      <td
                        align="right"
                        valign="top"
                        width="60%"
                        //   style="padding: 20px 0 0 0;font-size: 14px; line-height: 14px; font-family: 'Open Sans', sans-serif; color: #000;"
                        style={{
                          padding: "20px 0 0 0",
                          fontSize: "14px",
                          lineHeight: "14px",
                          fontFamily: "'Open Sans', sans-serif",
                          color: "#000",
                        }}
                        class="padding-copy2"
                      >
                        <ul
                          class="contacts"
                          style={{
                            lineHeight: "0.8",
                          }}
                        >
                          <li>{company?.companyName}</li>
                          <br />
                          <li>{company?.address}</li>
                          <br />

                          <li>
                            Email Us:{" "}
                            <a href={`mailto:${company?.email}`}>
                              {company?.email}
                            </a>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  //style="padding: 15px;"
                  style={{ padding: "15px" }}
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width:700px;"
                    style={{ maxWidth: "700px" }}
                    class="responsive-table"
                  >
                    <tr>
                      <td>
                        <table
                          width="100%"
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td
                              align="left"
                              // style="font-size:24px;font-weight:600;font-family:'Open Sans', sans-serif;color:#000;padding-top:30px;"
                              style={{
                                fontSize: "24px",
                                fontWeight: "600",
                                fontFamily: "'Open Sans', sans-serif",
                                color: "#000",
                                paddingTop: "30px",
                              }}
                              class="padding-copy"
                            >
                              PROFORMA INVOICE
                            </td>
                          </tr>
                          <tr>
                            <td
                              align="left"
                              // style="font-size: 16px; font-family: 'Open Sans', sans-serif; color: #000; padding-top: 30px;"
                              style={{
                                fontSize: "16px",
                                fontFamily: "'Open Sans', sans-serif",
                                color: "#000",
                                paddingTop: "30px",
                              }}
                              class="padding-copy"
                            >
                              Invoice To,
                            </td>
                          </tr>
                          <tr>
                            <td
                              align="left"
                              // style="padding: 20px 15px 0 30px; font-size: 16px; line-height: 25px; font-family: 'Open Sans', sans-serif; color: #000;"
                              style={{
                                padding: "20px 15px 0 30px",
                                fontSize: "16px",
                                lineHeight: "25px",
                                fontFamily: "'Open Sans', sans-serif",
                                color: "#000",
                              }}
                              class="padding-copy"
                            >
                              {company?.companyName}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  // style="padding: 15px;"
                  style={{ padding: "15px" }}
                  class="padding"
                >
                  <table
                    frame="box"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;border: 1px solid #ececec;background-color: #fafafa;"
                    style={{
                      maxWidth: "700px",
                      border: "1px solid #ececec",
                      backgroundColor: "#fafafa",
                    }}
                    class="responsive-table"
                  >
                    <tr>
                      <td>
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          width="100%"
                          // style="background-color: #e6e6e6;"
                          style={{ backgroundColor: "#e6e6e6" }}
                        >
                          <tr>
                            <td valign="top" class="mobile-wrapper">
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="100%"
                                //   style="width: 100%;margin-left: 10px;margin-top: 5px;"
                                style={{
                                  width: "100%",
                                  marginLeft: "10px",
                                  marginTop: "5px",
                                }}
                                align="left"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 0 10px 0;"
                                    style={{ padding: "0 0 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family:Arial, sans-serif;color:#000;font-size:16px;font-weight:600;padding-top:6px"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            paddingTop: "6px",
                                          }}
                                        >
                                          INVOICE DETAILS
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <br />

                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="100%"
                        >
                          <tr>
                            <td valign="top" class="mobile-wrapper">
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="35%"
                                //   style="width: 35%;margin-left: 15px;"
                                style={{ width: "35%", marginLeft: "15px" }}
                                align="left"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 0 10px 0;"
                                    style={{ padding: "0 0 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family: Arial, sans-serif; color: #000; font-size: 16px;"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <b>Invoice No.:</b>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>

                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="60%"
                                //   style="width: 60%;"
                                style={{ width: "60%" }}
                                align="right"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 10px 10px 0;"
                                    style={{ padding: "0 10px 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="center"
                                          // style="font-family: Arial, sans-serif; color: #000;text-align: left; font-size: 16px;padding-right: 15px;"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            textAlign: "left",
                                            fontSize: "16px",
                                            paddingRight: "15px",
                                          }}
                                        >
                                          {bookingDetailsById?.invoice_code_num}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="100%"
                        >
                          <tr>
                            <td
                              valign="top"
                              // style="padding: 0;"
                              style={{ padding: "0" }}
                              class="mobile-wrapper"
                            >
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="35%"
                                //   style="width: 35%;margin-left: 13px;"
                                style={{ width: "35%", marginLeft: "13px" }}
                                align="left"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 0 10px 0;"
                                    style={{ padding: "0 0 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family: Arial, sans-serif; color: #000; font-size: 16px;"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <b>Booking ID.:</b>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>

                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="60%"
                                //   style="width: 60%;"
                                style={{ width: "60%" }}
                                align="right"
                              >
                                <tr>
                                  <td
                                    //  style="padding: 0 10px 10px 0;"
                                    style={{ padding: "0 10px 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="center"
                                          // style="font-family: Arial, sans-serif; color: #000;text-align: left; font-size: 16px;padding-right: 15px;"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            textAlign: "left",
                                            fontSize: "16px",
                                            paddingRight: "15px",
                                          }}
                                        >
                                          {bookingDetailsById?.bookingId}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="100%"
                        >
                          <tr>
                            <td
                              valign="top"
                              // style="padding: 0;"
                              style={{ padding: "0" }}
                              class="mobile-wrapper"
                            >
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="35%"
                                //   style="width: 35%;margin-left: 15px;"
                                style={{ width: "35%", marginLeft: "15px" }}
                                align="left"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 0 10px 0;"
                                    style={{ padding: "0 0 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="font-family: Arial, sans-serif; color: #000; font-size: 16px;"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <b>Invoice Date:</b>
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>

                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="60%"
                                //   style="width: 60%;"
                                style={{ width: "60%" }}
                                align="right"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 10px 10px 0;"
                                    style={{ padding: "0 10px 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="center"
                                          // style="font-family: Arial, sans-serif; color: #000;text-align: left; font-size: 16px;padding-right: 15px;"
                                          style={{
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            textAlign: "left",
                                            fontSize: "16px",
                                            paddingRight: "15px",
                                          }}
                                        >
                                          {moment().format("DD/MM/YYYY")}
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  // style="padding: 15px;"
                  style={{ padding: "15px" }}
                  class="padding"
                >
                  <table
                    frame="box"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;border: 1px solid #ececec;background-color: #fafafa;"
                    style={{
                      maxWidth: "700px",
                      border: "1px solid #ececec",
                      backgroundColor: "#fafafa",
                    }}
                    class="responsive-table"
                  >
                    <tr>
                      <td>
                        <table
                          cellspacing="0"
                          cellpadding="0"
                          width="100%"
                          // style="background-color: #e6e6e6;"
                          style={{ backgroundColor: "#e6e6e6" }}
                        >
                          <tr>
                            <td valign="top" class="mobile-wrapper">
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="100%"
                                //   style="width: 100%;margin-left: 10px;margin-top: 5px;"
                                style={{
                                  width: "100%",
                                  marginLeft: "10px",
                                  marginTop: "5px",
                                }}
                                align="left"
                              >
                                <tr>
                                  <td
                                    // style="padding: 0 0 10px 0;"
                                    style={{ padding: "0 0 10px 0" }}
                                  >
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="98%"
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          width="65%"
                                          // style="width:65%;font-family:Arial, sans-serif;color:#000;font-size:16px;font-weight:600;padding-top:6px;"
                                          style={{
                                            width: "65%",
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            paddingTop: "6px",
                                          }}
                                        >
                                          DESCRIPTION
                                        </td>
                                        <td
                                          align="right"
                                          width="25%"
                                          // style="width:25%;font-family:Arial, sans-serif;color:#000;font-size:16px;font-weight:600;padding:6px 10px;"
                                          style={{
                                            width: "25%",
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                            fontWeight: "600",
                                            padding: "6px 20px",
                                          }}
                                        >
                                          AMOUNT
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <br />

                        <table
                          cellspacing="0"
                          cellpadding="0"
                          border="0"
                          width="100%"
                        >
                          <tr>
                            <td valign="top" class="mobile-wrapper">
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="70%"
                                //   style="width: 70%;margin-left: 15px;"
                                style={{
                                  width: "70%",
                                  marginLeft: "15px",
                                }}
                                align="left"
                              >
                                <tr>
                                  <td>
                                    <table
                                      cellpadding="0"
                                      cellspacing="0"
                                      border="0"
                                      width="100%"
                                    >
                                      <tr>
                                        <td
                                          align="left"
                                          // style="padding: 0 0 10px 0;font-family: Arial, sans-serif; color: #000; font-size: 16px;"
                                          style={{
                                            padding: "0 0 10px 0",
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <b>From:</b>{" "}
                                          {
                                            bookingDetailsById?.source
                                              ?.placename
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          // style="padding:0 0 10px 0;font-family:Arial, sans-serif;color:#000;text-align:left;font-size:16px;"
                                          style={{
                                            padding: "0 0 10px 0",
                                            fontFamily: "Arial, sans-serif",
                                            color: "#000",
                                            textAlign: "left",
                                            fontSize: "16px",
                                          }}
                                        >
                                          <b>To:</b>{" "}
                                          {
                                            bookingDetailsById?.destination
                                              ?.placename
                                          }
                                        </td>
                                      </tr>
                                    </table>
                                  </td>
                                </tr>
                              </table>

                              <table
                                cellpadding="0"
                                cellspacing="0"
                                border="0"
                                width="25%"
                                //   style="width: 25%;"
                                style={{
                                  width: "25%",
                                }}
                                align="right"
                              >
                                <tr>
                                  <td
                                    align="right"
                                    //   style="font-family: Arial, sans-serif; color: #000;font-size: 16px;padding:0 15px 10px 0;"
                                    style={{
                                      fontFamily: "Arial, sans-serif",
                                      color: "#000",
                                      fontSize: "16px",
                                      padding: "0 15px 10px 0",
                                    }}
                                  >
                                    {bookingDetailsById?.priceDetails
                                      ?.currency +
                                      " " +
                                      Math.round(
                                        bookingDetailsById?.priceDetails?.amount
                                      )}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  // style="padding: 15px 15px 5px 15px;"
                  style={{ padding: "15px 15px 5px 15px" }}
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;"
                    style={{ maxWidth: "700px" }}
                    class="responsive-table"
                  >
                    <tr>
                      <td align="right">
                        <table
                          width="100%"
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td
                              align="right"
                              // style="padding: 0; font-size: 16px; line-height: 18px; font-family: 'Open Sans', sans-serif; color:#000;"
                              style={{
                                padding: "0",
                                fontSize: "16px",
                                lineHeight: "18px",
                                fontFamily: "'Open Sans', sans-serif",
                                color: "#000",
                              }}
                              class="padding-copy alignRight"
                            >
                              <b>
                                Total Amount{" "}
                                {bookingDetailsById?.priceDetails?.currency +
                                  " " +
                                  Math.round(
                                    bookingDetailsById?.priceDetails?.amount
                                  )}
                              </b>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  // style="padding: 15px 15px 5px 15px;"
                  style={{ padding: "15px 15px 5px 15px" }}
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;"
                    style={{ maxWidth: "700px" }}
                    class="responsive-table"
                  >
                    <tr>
                      <td>
                        <table
                          width="100%"
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td>
                              <table
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                              >
                                <tr>
                                  <td
                                    align="left"
                                    //   style="padding: 0; font-size: 14px; line-height: 18px; font-family: 'Open Sans', sans-serif; color:#000;"
                                    style={{
                                      padding: "0",
                                      fontSize: "14px",
                                      lineHeight: "18px",
                                      fontFamily: "'Open Sans', sans-serif",
                                      color: "#000",
                                    }}
                                    class="padding-copy"
                                  >
                                    Thank you for your business!
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  //   style="padding: 15px;"
                  style={{ padding: "15px" }}
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;"
                    style={{ maxWidth: "700px" }}
                    class="responsive-table"
                  >
                    <tr>
                      <td>
                        <table
                          width="100%"
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td>
                              <table
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                              >
                                <tr>
                                  <td
                                    align="left"
                                    //   style="padding: 0 0 0 0; font-size: 15px; line-height: 18px; font-family: 'Open Sans', sans-serif; color:#000;"
                                    style={{
                                      padding: "0 0 0 0",
                                      fontSize: "15px",
                                      lineHeight: "18px",
                                      fontFamily: "'Open Sans', sans-serif",
                                      color: "#000",
                                    }}
                                    class="padding-copy"
                                  >
                                    Best Regards,
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    align="left"
                                    //   style="padding: 5px 0 0 0; font-size: 15px; line-height: 18px; font-family: 'Open Sans', sans-serif; color:#000;"
                                    style={{
                                      padding: "5px 0 0 0",
                                      fontSize: "15px",
                                      lineHeight: "18px",
                                      fontFamily: "'Open Sans', sans-serif",
                                      color: "#000",
                                    }}
                                    class="padding-copy"
                                  >
                                    Your {company?.companyName} Team
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr>
                <td
                  bgcolor="#ffffff"
                  align="center"
                  //    style="padding: 15px;"
                  style={{ padding: "15px" }}
                >
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    //   style="max-width: 700px;"
                    style={{ maxWidth: "700px" }}
                    class="responsive-table"
                  >
                    <tr>
                      <td>
                        <table
                          width="100%"
                          border="0"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <tr>
                            <td>
                              <table
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                              >
                                <tr>
                                  <td
                                    align="left"
                                    //   style="padding: 0 0 0 0; font-size: 14px; line-height: 18px; font-family: 'Open Sans', sans-serif; color:grey; font-style: italic;"
                                    style={{
                                      padding: "0 0 0 0",
                                      fontSize: "14px",
                                      lineHeight: "18px",
                                      fontFamily: "'Open Sans', sans-serif",
                                      color: "grey",
                                      fontStyle: "italic",
                                    }}
                                    class="padding-copy"
                                  >
                                    DISCLAIMER:
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <table
                                width="100%"
                                border="0"
                                cellspacing="0"
                                cellpadding="0"
                              >
                                <tr>
                                  <td
                                    align="left"
                                    //   style="padding: 0 0 0 0; font-size: 10px; line-height: 18px; font-family: 'Open Sans', sans-serif; color: #aaaaaa; font-style: italic;"
                                    style={{
                                      padding: "0 0 0 0",
                                      fontSize: "10px",
                                      lineHeight: "18px",
                                      fontFamily: "'Open Sans', sans-serif",
                                      color: "#aaaaaa",
                                      fontStyle: "italic",
                                    }}
                                    class="padding-copy"
                                  >
                                    This e-mail contains PRIVILEGED AND
                                    CONFIDENTIAL INFORMATION intended solely for
                                    the use of the addressee(s). If you are not
                                    the intended recipient, please notify the
                                    sender by e-mail and delete the original
                                    message. Further, you are not to copy,
                                    disclose, or distribute this e-mail or its
                                    contents to any other person and any such
                                    actions are unlawful. This e-mail may
                                    contain viruses. {company?.companyName} has
                                    taken every reasonable precaution to
                                    minimize this risk, but is not liable for
                                    any damage you may sustain as a result of
                                    any virus in this e-mail. You should carry
                                    out your own virus checks before opening the
                                    e-mail or attachment. {company?.companyName}{" "}
                                    reserves the right to monitor and review the
                                    content of all messages sent to or from this
                                    e-mail address. Messages sent to or from
                                    this e-mail address may be stored on the{" "}
                                    {company?.companyName} e-mail system.
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <div className="flex justify-center mt-5 space-x-2">
              <div
                onClick={downloadInvoice}
                className="flex space-x-1 bg-secondary  text-white cursor-pointer hover:bg-gray-300 hover:text-black px-2 py-1 rounded-sm"
              >
                <DownloadIcon className="w-5 text-center" />

                <div className="text-sm font-medium">Download</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invoice;
